import { hspThreshold } from './constants';
/** Escape HTML special characters to prevent XSS when injecting into innerHTML */
export function escapeHtml(text) {
    return text
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
/**
 * Redirect method to be able to stub the redirect in end to end tests
 *
 * @param {string} url
 */
export const redirect = (url) => {
    window.location.href = url;
};
window.redirect = redirect;
export function hideOnClickOutside(element) {
    const outsideClickListener = (event) => {
        if (!element.contains(event.target)) {
            element.classList.add('hidden');
        }
    };
    document.addEventListener('click', outsideClickListener);
    document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
            element.classList.add('hidden');
        }
    });
}
export const isWebview = () => {
    return navigator.userAgent.startsWith('app-');
};
export const getSite = () => {
    return window.location.pathname.split('/')[1];
};
// From https://stackoverflow.com/a/47614491
export const setHTMLWithScripts = function (elm, html, mode = 'inner', selector) {
    if (mode === 'outer' && !selector) {
        throw new Error('Selector is required when using outer mode');
    }
    if (mode === 'outer') {
        elm.outerHTML = html;
    }
    else {
        elm.innerHTML = html;
    }
    // Needs to re-query element since the reference might have changed in case of outerHTML
    const replacedElm = mode === 'outer' ? document.querySelector(selector) : elm;
    Array.from(replacedElm.querySelectorAll('script')).forEach((oldScript) => {
        eval(oldScript.innerHTML);
    });
};
export const getRootUrl = () => {
    const origin = window.location.origin;
    const defaultLocale = 'fr-fr';
    const htmlLang = document.documentElement.lang.trim();
    if (!htmlLang || !htmlLang.includes('-')) {
        return `${origin}/${defaultLocale}`;
    }
    const [language, country] = htmlLang.split('-');
    const locale = `${country}-${language}`.toLowerCase();
    return `${origin}/${locale}`;
};
export const getCurrentBrand = () => document.documentElement.dataset.theme === 'octobre' ? 'octobre' : 'sezane';
export const getCountryFromDataSite = () => {
    try {
        const siteData = document.querySelector('body')?.dataset.site;
        if (!siteData) {
            return null;
        }
        return JSON.parse(siteData).code || null;
    }
    catch {
        return null;
    }
};
export const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};
export const getRoute = (routeList) => {
    if (!routeList) {
        console.error('Missing routeList for getRoute function');
        return null;
    }
    let url = getRootUrl() + "/";
    const locale = document.documentElement.lang.toLowerCase() || 'fr-fr';
    const lang = locale.split('-')[0];
    if (routeList[lang] !== undefined) {
        url += routeList[lang];
    }
    else {
        url += routeList.en;
    }
    return url;
};
const hspEquation = (r, g, b) => {
    // HSP equation from http://alienryderflex.com/hsp.html
    return Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
};
export const getContrastedColor = (hexColorToTest, defaultColor) => {
    const normalized = hexColorToTest.replace(/^#/, '');
    const full = normalized.length === 3
        ? normalized.split('').map((c) => c + c).join('')
        : normalized;
    const r = parseInt(full.slice(0, 2), 16);
    const g = parseInt(full.slice(2, 4), 16);
    const b = parseInt(full.slice(4, 6), 16);
    const hsp = hspEquation(r, g, b);
    return hsp <= hspThreshold ? hexColorToTest : defaultColor;
};
